import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { WidgetView, WidgetViewProps } from 'src/models/WidgetView';
import { getTAAComponentConfig } from 'src/components/Widgets/WidgetUtils';
import { TaaConfigsContextProvider, TimeOffBalanceTiles } from '@amzn/atoz-dashboard-taa-components';

export interface TimeOffBalancesViewProps extends WidgetViewProps {}

const TimeOffBalancesView: WidgetView = ({ employeeInfo }: TimeOffBalancesViewProps) => {
  const taaConfigs = getTAAComponentConfig(employeeInfo);
  return (
    <>
      <QueryClientProvider client={new QueryClient()}>
        <TaaConfigsContextProvider taaConfigs={taaConfigs}>
          <TimeOffBalanceTiles
            employeeId={employeeInfo.employeeId}
            shouldUse1PBalancesAPI={taaConfigs.isBalances1PMigrationEnabled}
          />
        </TaaConfigsContextProvider>
      </QueryClientProvider>
    </>
  );
};

export default TimeOffBalancesView;
